module.exports = __webpack_public_path__ + "82a3c4a9436583143c9e329f321f8c6d.png";